import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import componentMapping from './componentMapping'

class FundApiComponent extends PureComponent {
  render() {
    const { api } = this.props
    const { component } = api || {}

    if (!component) {
      return null
    }

    const Component = componentMapping[component]

    if (!Component) {
      return null
    }

    const periodCode = api.data && api.data.period_code

    const componentData = { ...this.props, api: null }

    return <Component {...api} periodCode={periodCode} {...componentData} />
  }
}

FundApiComponent.propTypes = {
  api: PropTypes.shape({
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    id: PropTypes.string,
    component: PropTypes.string,
    popups: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    presentation: PropTypes.object,
  }),
}

export default FundApiComponent
